/**
 * Унифицированная мета состояния запроса для любого store.
 * Используется при инициализации и в экшенах (pending / success / error).
 */

export const setMeta = {
  initial: () => ({ pending: false, success: false, errors: {} as Record<string, unknown> }),
  pending: () => ({ pending: true, success: false, errors: {} as Record<string, unknown> }),
  success: () => ({ pending: false, success: true, errors: {} as Record<string, unknown> }),
  error: (errors: Record<string, unknown>) => ({ pending: false, success: false, errors }),
};

export type MetaState = ReturnType<typeof setMeta.initial>;
